// Redirect ("link") helpers shared by the Sliders and Banners pages.
// A link is either null (no redirect) or { type, value?, label } — see the
// backend's src/common/bannerContent.js for the matching validation.

export const LINK_OPTIONS = [
  { type: "call", label: "Call" },
  { type: "whatsapp", label: "WhatsApp" },
  { type: "test", label: "Particular Test" },
  { type: "package", label: "Particular Package" },
  { type: "all_packages", label: "All Packages Page" },
  { type: "category", label: "Category Page" },
  { type: "prescription", label: "Upload Prescription" },
  { type: "reports", label: "Reports Page" },
  { type: "bookings", label: "Bookings Page" },
  { type: "male_age_group", label: "Men – Age Group" },
  { type: "female_age_group", label: "Women – Age Group" },
  { type: "search", label: "Search Tests & Packages" },
  { type: "cart", label: "Cart Page" },
  { type: "url", label: "External URL" },
];

export const AGE_GROUP_OPTIONS = [
  { value: "0", label: "All ages" },
  { value: "1", label: "0 - 5 yrs" },
  { value: "2", label: "6 - 17 yrs" },
  { value: "3", label: "18 - 99 yrs" },
];

export const PHONE_LINK_TYPES = ["call", "whatsapp"];
export const ITEM_LINK_TYPES = ["test", "package"];
export const AGE_LINK_TYPES = ["male_age_group", "female_age_group"];

export const isValidPhone = (value) => /^\d{10}$/.test(String(value || ""));
export const toPhoneDigits = (value) => String(value || "").replace(/\D/g, "").slice(0, 10);

export const getAgeGroupLabel = (value) =>
  AGE_GROUP_OPTIONS.find((item) => item.value === String(value))?.label || "";

const getOptionLabel = (type) => LINK_OPTIONS.find((item) => item.type === type)?.label || type;

/** Readable one-line description of a link, e.g. "Test: CBC" or "Women – 6 - 17 yrs". */
export const getLinkLabel = (link) => {
  if (!link || !link.type) return "";
  const { type, value, label } = link;
  switch (type) {
    case "call":
      return `Call: ${value || "-"}`;
    case "whatsapp":
      return `WhatsApp: ${value || "-"}`;
    case "test":
      return `Test: ${label || value || "-"}`;
    case "package":
      return `Package: ${label || value || "-"}`;
    case "category":
      return `Category: ${label || value || "-"}`;
    case "male_age_group":
      return `Men – ${getAgeGroupLabel(value) || label || "-"}`;
    case "female_age_group":
      return `Women – ${getAgeGroupLabel(value) || label || "-"}`;
    case "url":
      return `URL: ${value || "-"}`;
    default:
      return getOptionLabel(type);
  }
};

/** Returns an error message for an incomplete link, or "" when it is valid (null = no redirect). */
export const validateLink = (link) => {
  if (!link || !link.type) return "";
  const { type, value } = link;
  if (PHONE_LINK_TYPES.includes(type) && !isValidPhone(value)) {
    return "Enter a valid 10-digit mobile number";
  }
  if (ITEM_LINK_TYPES.includes(type) && !value) return `Select a ${type}`;
  if (type === "category" && !value) return "Select a category";
  if (AGE_LINK_TYPES.includes(type) && !getAgeGroupLabel(value)) return "Select an age group";
  if (type === "url" && !/^https?:\/\/\S+$/i.test(String(value || "").trim())) {
    return "Enter a valid http(s) URL";
  }
  return "";
};

/** Value for the multipart `link` field: JSON string, or "" for no redirect. */
export const serializeLink = (link) => {
  if (!link || !link.type) return "";
  const payload = { type: link.type, label: String(link.label || "").trim() };
  if (link.value !== undefined && link.value !== "") payload.value = String(link.value).trim();
  return JSON.stringify(payload);
};
